import type { Release } from '../releases';

export default {
  id: '2026-11-03-second-factor',
  at: '2026-11-04T10:23:00Z',
  title: 'Второй фактор при входе, проверка утёкших паролей, список сеансов',
  modules: ['admin'],
  items: [
    'Владельцам компаний, людям с доступом к деньгам, администраторам и внешним участникам после пароля нужен код: из приложения-генератора на телефоне (Google Authenticator, Яндекс Ключ и другие) или из Telegram. При первом входе приложение подключается прямо на экране входа по QR-коду, а портал выдаёт 10 одноразовых кодов восстановления.',
    'Отметка «Доверять этому устройству» — код на этом браузере не спрашивается 7 дней. Вход по Face ID, Touch ID и Windows Hello код не спрашивает. Неверные коды считаются вместе с неверными паролями: при переборе вход блокируется.',
    'Пароль, который встречался в утечках, повторяет почту или состоит из простой последовательности, задать нельзя. Проверка идёт на сервере портала, пароль никуда не отправляется.',
    'В «Профиле» — «Второй фактор» (подключить другой телефон, новые коды восстановления, забыть доверенные устройства) и «Сеансы входа»: где открыт вход и кнопка «Завершить» у каждого сеанса.',
  ],
  why: 'Пароль от учётной записи с доступом к деньгам или администрированию могли подобрать или узнать из чужой утечки. Теперь одного пароля для входа мало.',
  link: '/login',
} satisfies Release;
